// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Sweden */
const SE = /^(?:7[023689]\d{7})$/;

export default SE;
